/// <reference path="../_all.ts" />


//https://github.com/allenhwkim/angularjs-google-maps
//https://ngmap.github.io/#/!map_no_default_style.html

module partner {

  SimpleVendorAddressDirective.$inject = [
    'pageMetaService',
  ];
  export function SimpleVendorAddressDirective(
    pageMetaService : navigation.IPageMetaService,): ng.IDirective {

    return {
      restrict: 'AE',
      scope: {
        vendor: '=', 
        linkedin: '@', 
      },
      templateUrl: 'partner/SimpleVendorAddressDirective', 
      link: function (scope: IVendorAddressScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        
        scope.subjectQuery = function(template) {
          var page = pageMetaService.searchRouteParameter("ProductName");
          if (!page) page = pageMetaService.searchRouteParameter("MesuringTaskGroup");
          if (!page) page = pageMetaService.searchRouteParameter("Industry");
          if (page) {
            var title = page.DisplayName[pageMetaService.getPageMeta(navigation.HLFULL)];
            var subject = template.replace(/TITLE/g, title);
            return "?subject=" + encodeURI(subject);
          }
          return "";
        }

      }
    }
  }

}